/**
 * "A new version of StandingDocs is available. Reload."
 *
 * Shown once a newer build is live than the one this page is running (see
 * newVersion.ts). Reload is the person's choice; Later hides it until the
 * next time the page is opened.
 */
import { useState } from 'react';
import page from '../shared/Page.module.css';
import styles from './NewVersionBanner.module.css';
import { useNewVersion } from './newVersion';

export function NewVersionBanner({ running }: { running?: string }) {
  const available = useNewVersion(running);
  const [later, setLater] = useState(false);
  if (!available || later) return null;

  return (
    <div className={styles.banner} role="status">
      <span className={styles.text}>
        A new version of StandingDocs is available. Reload to use it; anything you have not
        saved on this page will be lost.
      </span>
      <span className={styles.actions}>
        <button type="button" className={`${page.btn} ${page.btnPrimary}`} onClick={() => window.location.reload()}>
          Reload
        </button>
        <button type="button" className={page.btn} onClick={() => setLater(true)}>Later</button>
      </span>
    </div>
  );
}
